import SelectionGrid from "#components/SelectionGrid/index.js";
import DropdownSelect from "#components/DropdownSelect/index.js";
import TranslatableTextField from "#components/TranslatableTextField/index.js";
import { Grid, TextField, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import LoadingButton from "components/LoadingButton";
import Dialog from "components/NoScrollDialog";
import { useLanguage } from "contexts/language.context";
import * as React from "react";
import { useEffect } from "react";
import entitiesService from "services/entities-service";

export default function TemplateCategoriesDialog({
  isOpen,
  onSubmit,
  data,
  mode,
  onClose,
}) {
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [updates, setUpdates] = React.useState({});
  const [initialTemplateCategory, setInitialTemplateCategory] = React.useState({
    name: { en: "" },
    referenceCode: "",
  });
  const [options, setOptions] = React.useState({ accounts: [] });
  const { label } = useLanguage();
  const [error, setError] = React.useState(null);

  const templateCategory = React.useMemo(
    () => ({
      ...initialTemplateCategory,
      ...updates,
    }),
    [initialTemplateCategory, updates],
  );

  useEffect(() => {
    setUpdates({});
  }, [initialTemplateCategory?.id]);

  async function fetch() {
    let [ok, data] = await entitiesService.getEntities();
    if (ok) {
      setOptions({ ...options, entities: data });
    }
  }

  React.useEffect(() => {
    if (!isOpen) return;
    setOpen(true);
    setLoading(false);
  }, [isOpen, mode]);

  React.useEffect(() => {
    if (data && mode == "edit")
      setInitialTemplateCategory({ ...data, name: data?.name });
    else
      setInitialTemplateCategory({
        name: "",
      });
  }, [data, mode, isOpen]);

  React.useEffect(() => {
    setError(null);
    if (isOpen) fetch();
  }, [mode, isOpen]);

  const handleClose = () => {
    setOpen(false);
    onClose();
  };

  const dropdownOptions = React.useMemo(() => {
    return {
      entities:
        options.entities?.map((v) => ({ id: v.id, label: v.name })) || [],
    };
  }, [options]);

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={open}
      onClose={handleClose}
      PaperProps={{
        component: "form",
        onSubmit: async (event) => {
          event.preventDefault();

          setLoading(true);
          const result = await onSubmit(templateCategory);

          if (result.error) {
            setError(result.error);
          } else {
            setError(null);
            handleClose();
          }

          setLoading(false);
        },
      }}
    >
      <DialogTitle>
        {mode == "edit"
          ? label("edit-template-category")
          : label("create-template-category")}
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h6" sx={{ fontSize: "14px", mb: 0 }}>
              Info
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <TranslatableTextField
              autoFocus
              required
              id="name"
              name="name"
              label={label("name-singular")}
              type="text"
              values={templateCategory.name}
              onChange={(e) =>
                setUpdates((prev) => ({ ...prev, name: e.target.value }))
              }
              fullWidth
            />
          </Grid>

          <SelectionGrid
            accountId={templateCategory.accountId}
            setAccountId={(accountId) => {
              setUpdates((prev) => ({ ...prev, accountId }));
            }}
          />
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>{label("cancel-button")}</Button>
        <LoadingButton
          loading={loading}
          type="submit"
          variant="gradient"
          color="info"
        >
          {mode == "edit" ? label("save-button") : label("create-button")}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
